import React from 'react'
import cx from 'classnames'

import { CardAction } from './CardAction'
import { CardProps } from './interfaces'

import cm from './Card.module.css'

const CardElement = <T extends React.ElementType = 'div'>({
  disabled,
  className,
  children,
  as,
  forwardedRef,
  ...rest
}: CardProps<T>) => {
  const cardClasses = cx(cm.card, className, {
    [cm.disabled]: disabled,
  })
  const CardComponent = as ?? 'div'

  return (
    <CardComponent {...rest} ref={forwardedRef} className={cardClasses} data-test-component="card">
      {children}
    </CardComponent>
  )
}

export const Card = Object.assign(CardElement, {
  Action: CardAction,
})
